import store from "@/store";
import api from "@/api";
import { cartManager as self } from "@/utilities";
import { getOrderTotal, generateFormatedDateTime } from "@/utilities/helper"
import { PiCKUP_TIME, ORDER_TYPE, PAYMENT_TYPE } from "@/utilities/enums";
import { isEmpty } from "lodash";
export default {

  async setCart(cart, _dispatch = true, submit = true) {

    if (_dispatch) {

      if (cart.coupon && cart.coupon_result && submit) {
        const couponResult = await self.updateCoupon(cart);
        cart = { ...cart, ...{ coupon_result: couponResult } }

      } else if (!cart.coupon) {
        cart = { ...cart, ...{ coupon_result: null } }
      }

      const totalResult = await self.setOrderTotal(cart);
      store.dispatch("cartStore/storeOrderTotal", totalResult.orderTotal);

    }
    store.dispatch("cartStore/saveNewCart", cart);
  },
  saveSelectedLocation: (locations, id = -1) => {
    let location = null;
    if (locations.length == 1 && id == -1) {
      location = locations[0];
    } else if (id > 0) {
      location = locations.find((x) => x.id === id);
    }
    store.dispatch("locationStore/storeSelectedLocation", location);
    store.dispatch("locationStore/fetchCategories", location.id)
  },
  generateCartObject: (cart, withComment = false) => {
    let objCart = [];

    cart.order.forEach((item) => {
      let currentOrderItem = self.generateOrderItem(item, withComment);

      //-- format the meal deal
      if (item.is_meal_deal && item.sections?.length) {

        currentOrderItem.subItems = [];

        item.sections.forEach(section => {
          if (section?.selected_items?.length) {

            let subItem = self.generateOrderItem(section, false)
            subItem.subItems = [];
            // add the bundle as an order item

            section.selected_items.forEach(selectedItem => {
              let subProductFound = section.subProducts.find(p => p.id == selectedItem.id)
              subItem.subItems.push(self.generateOrderItem({ ...subProductFound, ...{ quantity: selectedItem.quantity } }, false))
            })

            currentOrderItem.subItems.push(subItem);

          }
        })
      }
      objCart.push(currentOrderItem);
    });
    return objCart;
  },
  generateOrderItem(cartItem, withComment) {

    let obj = {
      id: cartItem.id,
      quantity: cartItem.quantity,
      comment: (withComment && cartItem.comment) ? cartItem.comment : null,
    };
    //-- format the meal deal
    if (cartItem.hasOptions && cartItem.options?.length) {

      const filtredOptionsWithSelectedValues = cartItem.options.filter(opt => !isEmpty(opt.selected) || opt?.selected_items?.length)

      let arrOptions = [];

      filtredOptionsWithSelectedValues.forEach((option) => {
        arrOptions.push(this.generateSelectedOption(option));
      });
      if(arrOptions.length){
        obj = {
          ...obj,
          ...{
            options: arrOptions
          }
        }
      }
    }
    return obj;
  },
  generateSelectedOption(option, parent_id = null) {

    let objOption = {
      id: option.id,
      quantity: 1, // default
      values: [],
      parent_id
    }
    if (option?.selected_items?.length) {
      option.selected_items
        .forEach((value) => {
          let subObject = {
            id: value.id,
            quantity: value.quantity,
            price: value.price,
          }
          // get the full value
          let valueFound = option.values.find(v => v.id == value.id)
          if (valueFound && valueFound.options?.length) {
            subObject = { ...subObject, ...{ options: [] } }
            valueFound.options.forEach(subOption => {
              subObject.options.push(this.generateSelectedOption(subOption, value.id))
            })
          }
          objOption.values.push(subObject);
        });
    }

    return objOption;

  },
  generateCouponObject: (cart) => {
    return new Promise(function (resolve) {
      let coupon = {
        cart: self.generateCartObject(cart, true),
        coupon: cart.coupon,
        order_type: cart.orderType,
        location_id: cart.locationId,
      };
      resolve(coupon);
    });
  },
  generateOrderObject: (cart, id) => {
    return new Promise(function (resolve) {
      let order = {
        location_id: id,
        cart: self.generateCartObject(cart, true),
        order_type: cart.orderType,
        order_for_date:
          cart.pickUp.type == PiCKUP_TIME.LATER
            ? generateFormatedDateTime(
              cart.pickUp.date,
              "date",
              "YYYY-MM-DD"
            ) +
            " " +
            generateFormatedDateTime(
              cart.pickUp.time,
              "time",
              "HH:mm:ss"
            )
            : null,
        total_price: cart.orderTotal,
        sub_total: cart.total,
        service_charge: cart.service_charge,
        bag_charge: cart.bag_charge,
        is_deliverect: cart.is_deliverect

      };

      //--- used for guest users
      if (cart.user) {
        order.first_name = cart.user.first_name;
        order.last_name = cart.user.last_name;
        order.telephone_number = cart.user.telephone_number;
        order.email = cart.user.email;
      }
      if (cart.orderType == ORDER_TYPE.Delivery.id) {
        order.delivery_fee = cart.delivery_fee;
        if (cart.driver_instructions)
          order.driver_instructions = cart.driver_instructions;

        if (cart.address.id) {
          order.address_id = cart.address.id;
        } else {
          order.address = {
            address_line_1: cart.address.address_line_1,
            address_line_2: cart.address.address_line_2,
            city: cart.address.city,
            region: cart.address.region,
            postcode: cart.address.postcode,
            country: cart.address.country,
            street_number: cart.address.street_number
          };
        }
      }

      if (cart.comment) order.comment = cart.comment;

      if (cart.coupon && cart.coupon_result) order.coupon = cart.coupon;

      if (cart.orderType == 3 && cart.table) order.table_id = cart.table.id;

      resolve(order);
    });
  },
  generatePaymentObject: (cart, idLocation, isNativePay = false) => {
    return new Promise(function (resolve) {
      let objPayment = {
        location_id: idLocation,
        order_id: cart.newOrder.id,
        payment_type: cart.payment_type,
      };
      if (cart.payment_type >= PAYMENT_TYPE.Card) {

        if (isNativePay && [PAYMENT_TYPE.ApplePay, PAYMENT_TYPE.GooglePay].includes(cart.payment_type)) {
          objPayment = {
            ...objPayment,
            ...{
              stripe_payment_method_id: cart.paymentMethodId
            }
          }
        } else {
          if (cart.card_id) objPayment.card_id = cart.card_id;
          else {
            objPayment = {
              ...objPayment,
              ...{
                card: cart.card,
                save_card: cart.save_card,
                first_name: cart.user.first_name,
                last_name: cart.user.last_name,
                telephone_number: cart.user.telephone_number,
                email: cart.user.email,
                service_charge: cart.service_charge,
                bag_charge: cart.bag_charge
              }
            }

          }
        }
      }
      resolve(objPayment);
    });
  },
  setOrderTotal: function (cart) {
    return new Promise((resolve) => {
      //---- reduce the coupon discount
      if (cart.coupon_result) {
        cart.orderTotal = cart.coupon_result.afterDiscountCartTotal;
        cart.total = cart.coupon_result.cartTotal;
      } else {
        let total = getOrderTotal(cart, cart.orderType);
        cart.orderTotal = total;
        cart.total = total;
      }
      if (cart.order.length) {
        cart.orderTotal += parseFloat(cart.service_charge);
        cart.orderTotal += parseFloat(cart.bag_charge);
        if (cart.orderType == ORDER_TYPE.Delivery.id)
          cart.orderTotal += cart.delivery_fee;
      }

      resolve(cart);
    });
  },
  updateCoupon: function (cart) {
    return new Promise((resolve) => {
      self.generateCouponObject(cart).then((coupon) => {
        self
          .postVerifyCoupon(coupon)
          .then((result) => {
            if (result.coupon) {
              resolve(result);
            } else {
              resolve(null);
            }
          })
          .catch(() => {
            resolve(null);
          });
      });
    });
  },
  postVerifyCoupon: (data) => {
    return new Promise((resolve, reject) => {
      api.coupon
        .veriy(data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e.response);
        });
    });
  },
};
